// removed by extract-text-webpack-plugin
module.exports = {"component":"_1Tm0sGI8JKTCWE-CNNV6XB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAddressForm/Br/SearchCEP/searchCEP.css
// module id = 1046
// module chunks = 2